import React from 'react';
import MyBoxLoader from 'components/MyBoxLoader';

// ==============================|| LOADER ||============================== //

export default function Loader() {
  return <MyBoxLoader variant="fullscreen" size={120} />;
}

